module.exports = __webpack_public_path__ + "img/pdf.0bd580e8.png";